<template>
    <div class="outer">
        <div style='position: relative'>
            <el-dialog :title="editDialogTitle" :visible="editVisible" :close-on-click-modal="false" @close="closeEditDialog" width="30%">
                <el-form ref="editForm" style="width: 80%" label-width="130px" :model="editForm" :rules="editRules">
                    <el-form-item
                    label="经手人部门名称"
                    prop="departmentId"
                    label-width="140px"
                    required
                    >
                        <treeselect
                            :disable-branch-nodes="true"
                            v-model="editForm.departmentId"
                            :options="deptOptions"
                            :clearable="false"
                            :default-expand-level="2"
                            :normalizer="normalizer"
                            placeholder="请选择部门名称"
                            @select="handleSelect"
                        />
                    </el-form-item>
                    <el-form-item
                    label="经手人名称"
                    prop="userId"
                    label-width="130px"
                    required
                    >
                        <el-select
                        class="userSelect"
                        style="width: 100%"
                        v-model="editForm.userId"
                        placeholder="请选择"
                        :popper-append-to-body="false"
                        clearable
                        >
                            <el-option
                            v-for="item in CeOptions"
                            :key="item.id"
                            :label="item.trueName"
                            :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                    label="应付金额"
                    prop="yfjk"
                    label-width="130px"
                    required
                    >
                        <el-input type="number" v-model="editForm.yfjk" placeholder="请输入应付金额"></el-input>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="editVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitEdit">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 导出：按当前选中的 tab，导出该列表当前筛选条件下的全部记录 -->
            <div style="display: flex; justify-content: flex-end; margin-bottom: 10px">
                <el-button type="success" @click="downloadExcel" size="small">
                    <i class="fa fa-level-down" aria-hidden="true"></i>
                    导出数据
                </el-button>
            </div>
            <el-tabs v-model="tabKey"  type="card">
                <el-tab-pane label="运输费用列表" name="1">
                    <el-dialog title="导入运输费用表" v-if="transformVisible" :visible="transformVisible" :close-on-click-modal="false"
                        @close="transformVisible = false; transformSuccessText = ''" width="35%">
                        <div class="flex-center" style="height: 400px;">
                            <el-upload class="upload" :limit="1" ref="transformUpload" drag
                                :before-upload="beforeUpload" :on-change="onFileChange" :auto-upload="false"
                                :http-request="customRequest" accept=".xlsx" :on-remove="onFileRemove"
                                :action="ipAddress + '/work/jxc/waybill_cost_excel'">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                <div class="el-upload__tip" slot="tip">只能上传xlsx,xls类型文件,格式必须和模板格式相同,否则可能会导入失败</div>
                            </el-upload>

                            <span slot="footer" class="dialog-footer">
                                <el-button size="medium" @click="downloadModel('transform')"
                                    style="margin-right: 30px;">下载模板</el-button>
                                <el-button size="medium" type="primary"
                                    :disabled="transformFileList.length === 0 || disabled"
                                    @click="uploadSubmit">确认上传</el-button>
                            </span>

                            <div style="margin-top: 20px; font-size: 17px;">{{ transformSuccessText }}</div>
                        </div>
                    </el-dialog>

                    <div class="topSearch">
                        <el-form :inline="true">
                            <el-form-item label="费用状态" style="margin-right: 20px">
                                <el-select v-model="transformQueryForm.costState" placeholder="请选择" @change="onTransformSearch">
                                    <el-option label="全部" :value="9"></el-option>
                                    <el-option label="待确认中" :value="1"></el-option>
                                    <el-option label="确认完毕" :value="2"></el-option>
                                    <el-option label="有异议驳回" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="经手人" v-if="userRoleId == '48' || userRoleId == '31'" style="margin-right: 20px">
                                <el-input v-model="transformQueryForm.jsr" clearable placeholder="请输入经手人"></el-input>
                            </el-form-item>

                            <el-form-item label="导入批次" style="margin-right: 20px">
                                <el-input v-model="transformQueryForm.billNo" clearable placeholder="请输入导入批次"></el-input>
                            </el-form-item>

                            <el-button type="primary" icon="el-icon-search" @click="onTransformSearch">搜索</el-button>

                        </el-form>

                        <div>
                            <el-button type="primary" v-if="userRoleId == '48' || userRoleId == '31'" icon="el-icon-upload" @click="transformVisible = true"
                                size="small">导入运输费用表</el-button>
                        </div>
                    </div>

                    <div style="margin-top: 10px">
                        <el-table :data="transformData" class="el-table" height="calc(100vh - 300px)" stripe border :row-style="{ height: '58px' }"
                            :cell-style="{ padding: '5px 0' }" size="small" fit v-loading="tLoading"
                            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%">
                            <el-table-column prop="year" label="年份" align="center">
                            </el-table-column>
                            <el-table-column prop="rq" label="日期" align="center">
                            </el-table-column>
                            <el-table-column prop="ydhm" label="运单号码" width="150" align="center">
                            </el-table-column>
                            <el-table-column prop="jjdq" label="寄件地区" align="center" width="90">
                            </el-table-column>
                            <el-table-column prop="djdq" label="到件地区" align="center" width="90">
                            </el-table-column>
                            <el-table-column prop="dfgsmc" label="对方公司名称" width="120" align="center">
                            </el-table-column>
                            <el-table-column prop="jfzl" label="计费重量" align="center" width="90">
                            </el-table-column>
                            <el-table-column prop="cplx" label="产品类型" width="100" align="center">
                            </el-table-column>
                            <el-table-column prop="fkfs" label="付款方式" align="center" width="90">
                            </el-table-column>
                            <!-- <el-table-column prop="fy" label="费用(元)" align="center">
                            </el-table-column> -->
                            <el-table-column prop="zk" label="折扣/促销" align="center" width="90">
                            </el-table-column>
                            <el-table-column prop="yfjk" label="应付金额" align="center" width="90">
                            </el-table-column>
                            <el-table-column prop="jsr" label="经手人" align="center">
                            </el-table-column>
                            <el-table-column prop="fw" label="服务" align="center">
                            </el-table-column>
                            <el-table-column prop="billNo" label="导入批次" width="150" align="center">
                            </el-table-column>
                            <el-table-column prop="costState" label="费用状态" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="costStateType(scope.row.costState)">{{ costStateText(scope.row.costState) }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="impTime" label="数据导入时间" width="150" align="center" :formatter="dateTimeTwoLine" class-name="cell-two-line">
                            </el-table-column>
                            <el-table-column prop="classFlag" label="费用流向" width="150" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.classFlag === 'sale' ? '销售资金池表' : '部门成本表' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="opinion" label="意见" width="150" align="center">
                                <template slot-scope="scope" >
                                    {{ scope.row.costState !== '1' ? scope.row.opinion : '--' }}
                                </template>     
                            </el-table-column>
                            <el-table-column prop="operate" fixed="right" label="操作" width="300" align="center">
                                <template slot-scope="scope">
                                    <template v-if="userName === scope.row.jsr">
                                        <el-button type="primary" size="mini"
                                        @click="handleOk(scope.row, '2')" :disabled="scope.row.costState !== '1'">确认</el-button>
                                        <el-button type="danger" size="mini"
                                        @click="handleOk(scope.row, '3')" :disabled="scope.row.costState !== '1'">驳回</el-button>
                                    </template>
                                    <template v-if="userRoleId === '48' || userRoleId === '31'">
                                        <el-button type="primary" size="mini" :disabled="scope.row.costState === '2'"
                                        @click="handleEdit(scope.row)">修改</el-button>
                                        <el-button type="danger" size="mini" :disabled="scope.row.costState === '2'"
                                        @click="handleDelete(scope.row)">删除</el-button>
                                    </template>
                                    
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <!-- 分页 -->
                    <div style="display: flex; justify-content: space-between; margin-top: 20px">

                        <div>应付总金额: {{ transformTotalPrice }}元</div>

                        <el-pagination background @current-change="tCurrentChange" @size-change="tSizeChange" :total="tranTotal"
                            :page-size="transformQueryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="transformQueryForm.page"
                            layout="sizes, prev, pager, next, jumper, ->, total">
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="办公费用列表" name="2">
                    <el-dialog title="导入办公费用表" v-if="workVisible" :visible="workVisible" :close-on-click-modal="false"
                        @close="workVisible = false; workSuccessText = ''" width="35%">
                        <div class="flex-center" style="height: 400px;">
                        <el-upload class="upload flex-center" :limit="1" ref="workUpload" drag
                            :before-upload="beforeUpload" :on-change="onFileChange" :auto-upload="false"
                            :http-request="customRequest" accept=".xlsx" :on-remove="onFileRemove"
                            :action="ipAddress + '/work/jxc/waybill_cost_excel'">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div class="el-upload__tip" slot="tip">只能上传xlsx,xls类型文件,格式必须和模板格式相同,否则可能会导入失败</div>
                        </el-upload>

                        <span slot="footer" class="dialog-footer">
                            <el-button size="medium" @click="downloadModel('work')"
                                style="margin-right: 30px;">下载模板</el-button>
                            <el-button size="medium" type="primary" :disabled="workFileList.length === 0 || disabled"
                                @click="uploadSubmit">确认上传</el-button>
                        </span>

                        <div style="margin-top: 20px; font-size: 17px;">{{ workSuccessText }}</div>
                        </div>
                    </el-dialog>

                    <div class="topSearch">
                        <el-form :inline="true">
                            <el-form-item label="费用状态" style="margin-right: 20px">
                                <el-select v-model="workQueryForm.costState" placeholder="请选择" @change="onWorkSearch">
                                    <el-option label="全部" :value="9"></el-option>
                                    <el-option label="待确认中" :value="1"></el-option>
                                    <el-option label="确认完毕" :value="2"></el-option>
                                    <el-option label="有异议驳回" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item label="经手人" v-if="userRoleId == '48' || userRoleId == '31'" style="margin-right: 20px">
                                <el-input v-model="workQueryForm.jsr" clearable placeholder="请输入经手人"></el-input>
                            </el-form-item>

                            <el-form-item label="导入批次" style="margin-right: 20px">
                                <el-input v-model="workQueryForm.billNo" clearable placeholder="请输入导入批次"></el-input>
                            </el-form-item>

                            <el-button type="primary" icon="el-icon-search" @click="onWorkSearch">搜索</el-button>

                        </el-form>

                        <div>
                            <el-button type="primary" icon="el-icon-upload" @click="workVisible = true" v-if="userRoleId == '48' || userRoleId == '31'"
                                size="small">导入办公费用表</el-button>
                        </div>
                    </div>

                    <div style="margin-top: 10px">
                        <el-table :data="workData" class="el-table" height="calc(100vh - 300px)" stripe border :row-style="{ height: '58px' }"
                            :cell-style="{ padding: '5px 0' }" size="small" fit v-loading="wLoading"
                            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%">
                            <el-table-column prop="rq" label="费用日期" align="center">
                            </el-table-column>
                            <el-table-column prop="dydmc" label="打印店名称" align="center" width="100">
                            </el-table-column>
                            <el-table-column prop="dynr" label="打印内容" align="center">
                            </el-table-column>
                            <el-table-column prop="fyje" label="应付金额" align="center" width="90">
                            </el-table-column>
                            <el-table-column prop="jsr" label="经手人" align="center">
                            </el-table-column>            
                            <el-table-column prop="billNo" label="导入批次" align="center">
                            </el-table-column>
                            <el-table-column prop="costState" label="费用状态" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="costStateType(scope.row.costState)">{{ costStateText(scope.row.costState) }}</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="impTime" label="数据导入时间" width="150" align="center" :formatter="dateTimeTwoLine" class-name="cell-two-line">
                            </el-table-column>
                            <el-table-column prop="classFlag" label="费用流向" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.classFlag === 'sale' ? '销售资金池表' : '部门成本表' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="opinion" label="意见" align="center">
                                <template slot-scope="scope" >
                                    {{ scope.row.costState !== '1' ? scope.row.opinion : '--' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="operate" label="操作" width="300" align="center">
                                <template slot-scope="scope">
                                    <template v-if="userName === scope.row.jsr">
                                        <el-button type="primary" size="mini"
                                        @click="handleOk(scope.row, '2')" :disabled="scope.row.costState != '1'">确认</el-button>
                                        <el-button type="danger" size="mini"
                                        @click="handleOk(scope.row, '3')" :disabled="scope.row.costState != '1'">驳回</el-button>
                                    </template>
                                    <template v-if="userRoleId === '48' || userRoleId === '31'">
                                        <el-button type="primary" size="mini" :disabled="scope.row.costState === '2'"
                                        @click="handleEdit(scope.row)">修改</el-button>
                                        <el-button type="danger" size="mini" :disabled="scope.row.costState === '2'"
                                        @click="handleDelete(scope.row)">删除</el-button>
                                    </template>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div style="display: flex; justify-content: space-between; margin-top: 20px">
                        <div>应付总金额: {{ workTotalPrice }}元</div>

                        <el-pagination background @current-change="wCurrentChange" @size-change="wSizeChange" :total="workTotal"
                            :page-size="workQueryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="workQueryForm.page"
                            layout="sizes, prev, pager, next, jumper, ->, total">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
import FileSaver from "file-saver";
import {
    importWaybillExcel, importOfficeExcel, getWaybillCostList, deleteWaybillCostStore, updateWaybillCostStore,
    getOfficeCostStore, updateOfficeCostStore, deleteOfficeCostStore, confirmWaybillCostStore, confirmOfficeCostStore
} from '@/api/proj';
import { getUserSelectByPage } from "@/api/plat/PlatStaff";
import store from '@/store';
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
    data() {
        return {
            userName: JSON.parse(sessionStorage.getItem('user')).trueName, // 当前登录用户名
            tLoading: false, // 运输费表格加载
            wLoading: false, // 办公费表格加载
            tranTotal: 0,   // 运输费表格总条数
            workTotal: 0,   // 办公费表格总条数
            editRules: {
                departmentId:[
                    { required: true, message: '请选择经办人部门' }
                ],
                userId:[
                    { required: true, message: '请选择经办人' }
                ],
                yfjk:[
                    { required: true, message: '请输入应付金额' }
                ],
            }, // 修改验证
            editDialogTitle: '', // 修改弹窗标题
            userRoleId: sessionStorage.getItem('userRoleId'),  // 当前登录用户角色ID
            transformVisible: false, // 运输费导入模块显隐
            workVisible: false, // 办公费导入模块显隐
            ipAddress: store.state.IPAss.TP, // 上传接口地址
            tabKey: '1', // 选项卡key
            transformFileList: [], // 运输费上传文件对象
            workFileList: [], // 办公费上传文件对象
            transformQueryForm: {
                page: 1,
                limit: 50,
                costState: 9,
                billNo: '',
            }, //运输费表查询
            workQueryForm:{
                page: 1,
                limit: 50,
                costState: 9,
                billNo: '',
            }, //办公费表查询
            transformSuccessText: '',  // 运输费上传成功后的文字
            workSuccessText: '',  // 办公费上传成功后的文字
            disabled: false,  // 文件上传按钮失效
            transformData: [],  // 运输费列表
            workData: [],  // 办公费列表
            editVisible: false,  // 编辑弹窗显隐
            editForm: {},  // 编辑表单数据
            deptOptions: [],   // 部门下拉数据
            CeOptions:[],   // 经办人下拉数据
        }
    },
    components: {
        Treeselect
    },
    async created() {
        this.getWaybillCostList();
        this.getOfficeCostStore();
        let deptArr = await this.getDimTableDeptByIds([213, 214, 216]);
        this.deptOptions = deptArr.data.concat([]);
    },
    computed: {
        workTotalPrice(){
            let total = 0;
            this.workData.forEach(item => {
                total += Number(item.fyje);
            });
            return total.toFixed(2);
        },
        transformTotalPrice(){
            let total = 0;
            this.transformData.forEach(item => {
                total += Number(item.yfjk);
            });
            return total.toFixed(2);
        }
    },
    watch:{
        'transformQueryForm.jsr':{
            handler(newVal) {
                if(!newVal){
                    this.transformQueryForm.page = 1;
                    this.getWaybillCostList();
                }
            },
        },
        'transformQueryForm.billNo':{
            handler(newVal) {
                if(!newVal){
                    this.transformQueryForm.page = 1;
                    this.getWaybillCostList();
                }
            },
        },
        'workQueryForm.jsr':{
            handler(newVal) {
                if(!newVal){
                    this.workQueryForm.page = 1;
                    this.getOfficeCostStore();
                }
            },
        },
        'workQueryForm.billNo':{
            handler(newVal) {
                if(!newVal){
                    this.workQueryForm.page = 1;
                    this.getOfficeCostStore();
                }
            },
        }
    },
    methods: {
        // 确认或者驳回
        handleOk(row,costState){
            let promptTitle = (costState == '2' ? "费用确认" : "费用驳回");
            this.$prompt('请输入意见', promptTitle, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: costState == '2' ? '同意' : '',
                inputPattern: /[^ \x20]+/,
                inputErrorMessage: '意见不能为空!'
            }).then(({ value }) => {
                if(this.tabKey == 1){
                    confirmWaybillCostStore({
                        xh: row.xh,
                        billNo: row.billNo,
                        costState,
                        opinion: value
                    }).then(res => {
                        if(res.code === 200){
                            this.getWaybillCostList();
                            this.$message({
                                type: 'success',
                                message: '操作成功'
                            });
                        }
                    })
                }else if(this.tabKey == 2){
                    confirmOfficeCostStore({
                        xh: row.xh,
                        billNo: row.billNo,
                        costState,
                        opinion: value
                    }).then(res => {
                        if(res.code === 200){
                            this.getOfficeCostStore();
                            this.$message({
                                type: 'success',
                                message: '操作成功'
                            });
                        }
                    })
                }
            })
        },
        closeEditDialog(){
            this.editForm = {};
            this.editVisible = false;
        },
        submitEdit(){
            this.$refs.editForm.validate(valid => {
                if(valid){
                    if(this.tabKey == 1){
                        updateWaybillCostStore(this.editForm).then(res => {
                            if(res.code === 200){
                                this.$message({
                                    type: 'success',
                                    message: '修改成功'
                                })
                                this.editVisible = false;
                                this.getWaybillCostList();
                            }
                        })
                    } else if(this.tabKey == 2){
                        this.editForm.fyje = this.editForm.yfjk;
                        delete this.editForm.yfjk;
                        updateOfficeCostStore(this.editForm).then(res => {
                            if(res.code === 200){
                                this.$message({
                                    type: 'success',
                                    message: '修改成功'
                                })
                                this.editVisible = false;
                                this.getOfficeCostStore();
                            }
                        })
                    }
                    
                }
            })
        },
        // 节点单击事件
        async handleSelect(node, instanceId) {
            this.editForm.userId = '';
            let { data } = await getUserSelectByPage({
                condition: {
                    departmentId: node.id,
                },
                limit: 9999,
                page: 1,
            });
            console.log(this.CeOptions);
            this.CeOptions = data.records;
        },
        /** 转换部门数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.id,
                label: node.name,
                children: node.children,
            };
        },
        tSizeChange(pageSize){
            this.transformQueryForm.page = 1;
            this.transformQueryForm.limit = pageSize;
            this.getWaybillCostList();
        },
        tCurrentChange(e){
            this.transformQueryForm.page = e;
            this.getWaybillCostList();
        },
        wSizeChange(pageSize){
            this.workQueryForm.page = 1;
            this.workQueryForm.limit = pageSize;
            this.getOfficeCostStore();
        },
        wCurrentChange(e){
            this.workQueryForm.page = e;
            this.getOfficeCostStore();
        },
        onTransformSearch(){
            this.transformQueryForm.page = 1;
            this.getWaybillCostList();
        },
        onWorkSearch(){
            this.workQueryForm.page = 1;
            this.getOfficeCostStore();
        },
        // 列表查询与导出共用同一套筛选参数，避免两处拼参不一致
        buildTransformQuery(page, limit){
            return Object.assign({}, this.transformQueryForm, { page: page, limit: limit });
        },
        buildWorkQuery(page, limit){
            return Object.assign({}, this.workQueryForm, { page: page, limit: limit });
        },
        // 获取快递费用列表
        getWaybillCostList(){
            this.tLoading = true;
            getWaybillCostList(this.buildTransformQuery(this.transformQueryForm.page, this.transformQueryForm.limit)).then(res => {
                if(res.code === 200){
                    this.tranTotal = res.count;
                    this.transformData = res.data;
                    this.tLoading = false;
                }
            })
        },
        // 获取办公费用列表
        getOfficeCostStore(){
            this.wLoading = true;
            getOfficeCostStore(this.buildWorkQuery(this.workQueryForm.page, this.workQueryForm.limit)).then(res => {
                if(res.code === 200){
                    this.workTotal = res.count;
                    this.workData = res.data;
                    this.wLoading = false;
                }
            })
        },
        // ==================== 导出 Excel（exceljs，数据驱动，不读 DOM） ====================
        // 文件名用的日期后缀：YYYYMMDD
        exportFileDate(){
            const d = new Date();
            const p = (n) => String(n).padStart(2, "0");
            return `${d.getFullYear()}${p(d.getMonth() + 1)}${p(d.getDate())}`;
        },
        // 费用流向翻译（与页面表格显示一致）
        classFlagText(classFlag){
            return classFlag === 'sale' ? '销售资金池表' : '部门成本表';
        },
        // 意见：未确认（costState=1）时页面显示 '--'，导出写空单元格
        opinionText(row){
            return String(row.costState) === '1' ? '' : row.opinion;
        },
        // 运输费用列表导出列：页面表格列去掉"操作"列
        getWaybillExportColumns(){
            return [
                { header: "年份", key: "year", width: 8 },
                { header: "日期", key: "rq", width: 12 },
                { header: "运单号码", key: "ydhm", width: 20 },
                { header: "寄件地区", key: "jjdq", width: 14 },
                { header: "到件地区", key: "djdq", width: 14 },
                { header: "对方公司名称", key: "dfgsmc", width: 24 },
                { header: "计费重量", key: "jfzl", width: 10 },
                { header: "产品类型", key: "cplx", width: 12 },
                { header: "付款方式", key: "fkfs", width: 12 },
                { header: "折扣/促销", key: "zk", width: 12 },
                { header: "应付金额", key: "yfjk", width: 13, money: true },
                { header: "经手人", key: "jsr", width: 12 },
                { header: "服务", key: "fw", width: 12 },
                { header: "导入批次", key: "billNo", width: 20 },
                {
                    header: "费用状态",
                    key: "costState",
                    width: 12,
                    format: (row) => this.costStateText(row.costState),
                },
                { header: "数据导入时间", key: "impTime", width: 20 },
                {
                    header: "费用流向",
                    key: "classFlag",
                    width: 16,
                    format: (row) => this.classFlagText(row.classFlag),
                },
                {
                    header: "意见",
                    key: "opinion",
                    width: 20,
                    align: "left",
                    format: (row) => this.opinionText(row),
                },
            ];
        },
        // 办公费用列表导出列：页面表格列去掉"操作"列
        getOfficeExportColumns(){
            return [
                { header: "费用日期", key: "rq", width: 12 },
                { header: "打印店名称", key: "dydmc", width: 24 },
                { header: "打印内容", key: "dynr", width: 28, align: "left" },
                { header: "应付金额", key: "fyje", width: 13, money: true },
                { header: "经手人", key: "jsr", width: 12 },
                { header: "导入批次", key: "billNo", width: 20 },
                {
                    header: "费用状态",
                    key: "costState",
                    width: 12,
                    format: (row) => this.costStateText(row.costState),
                },
                { header: "数据导入时间", key: "impTime", width: 20 },
                {
                    header: "费用流向",
                    key: "classFlag",
                    width: 16,
                    format: (row) => this.classFlagText(row.classFlag),
                },
                {
                    header: "意见",
                    key: "opinion",
                    width: 20,
                    align: "left",
                    format: (row) => this.opinionText(row),
                },
            ];
        },
        // 用数据数组生成 Excel（exceljs 体积较大，动态导入，仅在点击导出时加载）
        // rows      - 要导出的数据数组
        // fileName  - 文件名，如 "费用管理_运输费用_20260212.xlsx"
        // sheetName - 工作表名
        // columns   - 导出列定义（本页两个 tab 各一套，必须显式传入）
        async exportRowsToExcel(rows, fileName, sheetName, columns){
            const mod = await import(/* webpackChunkName: "exceljs" */ "exceljs");
            // 兼容 CJS 模块被 webpack 包装成 { default: ... } 的情况
            const ExcelJS = mod && mod.Workbook ? mod : mod && mod.default ? mod.default : mod;
            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet(sheetName || String(fileName || "Sheet1").replace(/\.xlsx$/i, ""));

            // 列定义（表头行由 columns.header 自动生成）
            sheet.columns = columns.map((col, i) => ({
                header: col.header,
                key: "c" + i,
                width: col.width,
            }));

            const thin = { style: "thin", color: { argb: "FFD0D0D0" } };

            // 表头样式：加粗 + 灰底 + 居中 + 边框
            const headerRow = sheet.getRow(1);
            headerRow.height = 22;
            headerRow.eachCell((cell) => {
                cell.font = { bold: true, size: 11, color: { argb: "FF515A6E" } };
                cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFEEF1F6" } };
                cell.alignment = { horizontal: "center", vertical: "middle" };
                cell.border = { top: thin, left: thin, bottom: thin, right: thin };
            });

            // 冻结首行：滚动时表头常驻
            sheet.views = [{ state: "frozen", ySplit: 1 }];

            // 数据行
            (rows || []).forEach((row) => {
                const values = columns.map((col) => {
                    const raw = col.format ? col.format(row) : row[col.key];
                    // 空值写成真正的空单元格，不写 "--"，避免影响 Excel 求和
                    if (raw === null || raw === undefined || raw === "") return null;
                    if (col.money) {
                        const n = Number(raw);
                        return isNaN(n) ? null : n;
                    }
                    return raw;
                });
                const added = sheet.addRow(values);

                columns.forEach((col, i) => {
                    const cell = added.getCell(i + 1);
                    cell.border = {
                        top: { style: "thin", color: { argb: "FFE8E8E8" } },
                        left: { style: "thin", color: { argb: "FFE8E8E8" } },
                        bottom: { style: "thin", color: { argb: "FFE8E8E8" } },
                        right: { style: "thin", color: { argb: "FFE8E8E8" } },
                    };
                    if (col.money) {
                        // 千分位 + 两位小数；保留数值类型，可在 Excel 中继续排序/求和
                        cell.numFmt = "#,##0.00";
                        cell.alignment = { horizontal: "right", vertical: "middle" };
                    } else {
                        cell.alignment = {
                            horizontal: col.align || "center",
                            vertical: "middle",
                        };
                    }
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            FileSaver.saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName);
        },
        // 导出入口：按当前选中的 tab，导出该列表当前筛选条件下的全部记录
        downloadExcel(){
            if (String(this.tabKey) === "2") {
                this.exportOfficeCostExcel();
            } else {
                this.exportWaybillCostExcel();
            }
        },
        // 运输费用列表导出（不渲染表格，无需还原分页状态）
        exportWaybillCostExcel(){
            const EXPORT_LIMIT = 99999; // 用超大 limit 让服务端返回"筛选后的全部记录"
            const fileName = "费用管理_运输费用_" + this.exportFileDate() + ".xlsx";
            this.tLoading = true;
            getWaybillCostList(this.buildTransformQuery(1, EXPORT_LIMIT)).then(res => {
                this.tLoading = false;
                const rows = (res && res.data) || [];
                if (!rows.length) {
                    this.$message({ type: 'warning', message: '当前筛选条件下没有数据' });
                    return;
                }
                return this.exportRowsToExcel(rows, fileName, "运输费用列表", this.getWaybillExportColumns()).catch(e => {
                    console.log(e);
                    this.$message({ type: 'error', message: '导出失败，请重试' });
                });
            }).catch(e => {
                this.tLoading = false;
                console.log(e);
            });
        },
        // 办公费用列表导出（不渲染表格，无需还原分页状态）
        exportOfficeCostExcel(){
            const EXPORT_LIMIT = 99999; // 用超大 limit 让服务端返回"筛选后的全部记录"
            const fileName = "费用管理_办公费用_" + this.exportFileDate() + ".xlsx";
            this.wLoading = true;
            getOfficeCostStore(this.buildWorkQuery(1, EXPORT_LIMIT)).then(res => {
                this.wLoading = false;
                const rows = (res && res.data) || [];
                if (!rows.length) {
                    this.$message({ type: 'warning', message: '当前筛选条件下没有数据' });
                    return;
                }
                return this.exportRowsToExcel(rows, fileName, "办公费用列表", this.getOfficeExportColumns()).catch(e => {
                    console.log(e);
                    this.$message({ type: 'error', message: '导出失败，请重试' });
                });
            }).catch(e => {
                this.wLoading = false;
                console.log(e);
            });
        },
        async handleEdit(row) {
            this.editDialogTitle = (this.tabKey == 1 ? '修改运输费用' : '修改办公费用');

            this.editForm = {
                departmentId: row.departmentId,
                userId: row.userId,
                yfjk: this.tabKey == 1 ? row.yfjk : row.fyje,
                billNo: row.billNo,
                xh: row.xh
            }
            let { data } = await getUserSelectByPage({
                condition: {
                    departmentId: row.departmentId,
                },
                limit: 9999,
                page: 1,
            });
            console.log(this.CeOptions);
            this.CeOptions = data.records;
            this.editVisible = true; 
        },
        // 处理删除事件
        handleDelete(row) {
            this.$confirm('确定删除这条费用信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if(this.tabKey == 1){
                    deleteWaybillCostStore({xh: row.xh, billNo: row.billNo}).then(res => {
                        if(res.code === 200){
                            this.getWaybillCostList();
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    })
                }else if(this.tabKey == 2){
                    deleteOfficeCostStore({xh: row.xh, billNo: row.billNo}).then(res => {
                        if(res.code === 200){
                            this.getOfficeCostStore();
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    })
                }
                   
            })
        },
        costStateText(costState){
            switch (costState){
                case '1':
                    return '待确认中';
                case '2':
                    return '确认完毕';
                case '3':
                    return '有异议驳回';
            }
        },
        costStateType(costState){
            switch (costState){
                case '1':
                    return '';
                case '2':
                    return 'success';
                case '3':
                    return 'danger';
            }
        },
        // 当文件被移除后
        onFileRemove(file, fileList) {
            if (this.tabKey == 1) {
                this.transformFileList = fileList;
            } else if (this.tabKey == 2) {
                this.workFileList = fileList;
            }
        },
        // 当文件改变时
        onFileChange(file, fileList) {
            if (this.tabKey == 1) {
                this.transformFileList = fileList;
            } else if (this.tabKey == 2) {
                this.workFileList = fileList;
            }
        },
        // 上传提交
        uploadSubmit() {
            if (this.tabKey == 1) {
                this.$refs.transformUpload.submit();
            } else if (this.tabKey == 2) {
                this.$refs.workUpload.submit();
            }
        },
        // 下载模板
        downloadModel(tag) {
            let link = document.createElement('a');
            link.style.display = 'none';
            if (tag === 'transform') {
                link.href = 'https://oa.yunqingtech.com/home/file_upload/pool/快递运单费用导入模板.xlsx';
                link.setAttribute('download', '快递运单费用导入模板.xlsx');

            } else if (tag === 'work') {
                link.href = 'https://oa.yunqingtech.com/home/file_upload/pool/办公打印费用导入模板.xlsx';
                link.setAttribute('download', '办公打印费用导入模板.xlsx');

            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        // 覆盖上传行为
        customRequest(option) {
            this.disabled = true;
            const loading = this.$loading({
                lock: true,
                text: '导入excel中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                customClass: 'loadingClass',
            });
            const formData = new FormData();
            formData.append('file', option.file);

            if (this.tabKey == 1) {
                importWaybillExcel(formData).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '导入成功'
                        });
                        this.transformQueryForm.page = 1;
                        this.getWaybillCostList();
                        this.transformSuccessText = res.msg;
                        loading.close();
                        this.disabled = false;
                    } else if (res.code === 500) {
                        this.$message({
                            type: 'error',
                            message: '导入文件格式有误!'
                        })
                        loading.close();
                        this.disabled = false;
                    } else {
                        loading.close();
                        this.disabled = false;
                    }
                    this.$refs.transformUpload.clearFiles();
                    this.transformFileList = [];
                })
            } else if (this.tabKey == 2) {
                importOfficeExcel(formData).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '导入成功'
                        })
                        this.workQueryForm.page = 1;
                        this.getOfficeCostStore();
                        this.workSuccessText = res.msg;
                        loading.close();
                        this.disabled = false;
                    } else if (res.code === 500) {
                        this.$message({
                            type: 'error',
                            message: '导入文件格式有误!'
                        })
                        loading.close();
                        this.disabled = false;
                    } else {
                        loading.close();
                        this.disabled = false;
                    }
                    this.$refs.workUpload.clearFiles();
                    this.workFileList = [];
                })
            }

        },
        // 在上传之前
        beforeUpload(file) {
            let ext = file.name.split('.')[1];
            console.log(ext);
            if (ext !== 'xlsx' && ext !== 'xls') {
                this.$message({
                    type: 'error',
                    message: '只能上传xlsx或xls类型文件'
                })
                return false;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.userSelect{
    ::v-deep .el-select-dropdown{
        z-index: 1 !important;
    }
}

.el-table{
    ::v-deep .el-table__cell{
        >:empty::before{
            content: '--';
            color: gray;
        }
    }
}

.flex-center {
    flex-direction: column;
    height: 100%;
}

.loadingClass {
    ::v-deep .el-icon-loading::before {
        font-size: 50px;
    }
}

.topSearch {
    display: flex;
    justify-content: space-between;
}

.upload {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;

    .upload__tip {
        margin-top: 30px;
    }
}
</style>